import * as z from "zod/v4";

export const putEcwidIntegration = {
  name: "putEcwidIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    storeId: z.string().min(1),
    accessToken: z.string().optional(),
    customerGroup: z.string().min(1),
    createForReturns: z.boolean(),
    createForClaims: z.boolean(),
    createForWarranties: z.boolean(),
    filterByReturnReason: z.boolean(),
    allowedReturnReasons: z.array(z.string()),
  }),
  output: z.object({}),
};
